export const API_METHOD = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
};

export const API_URLS = {
  baseurl: process.env.REACT_APP_DEV_API_URL,
  baseurlV2: process.env.REACT_APP_DEV_API_URL_V2,
  plusLead: {
    insert: '/siteVisits/broker/insert',
    getAllSitevisit: '/siteVisits/broker/getLeads',
    reSchedule: '/siteVisits/broker/reSchedule',
    tokenRequest: '/eoiDone/broker/tokenRequest',
    getCompanyName: '/public/getCompanyName',
    getBrokerSiteVisit: '/siteVisits/getBrokerSiteVisit',
    getTimeline: '/siteVisits/getTimeline',
    scheduleSiteVisit: '/siteVisit/broker/scheduleSiteVisit',
    rescheduleSiteVisit: '/siteVisit/broker/rescheduleSiteVisit'
  },
  plusSettings: {
    getUsersForSettings: '/brokercp/getUsersForSettings',
    inviteUserViaEmail: '/brokercp/inviteUserViaEmail',
    getUsers: '/company/getUsers'
  },

  lead: {
    getLeadDetail: "/leads/getLeadDetail",
    getActivityStatsByLeadUUID: "/leads/getActivityStatsByLeadUUID",
    getLatestActivityByLeadUUID: "/leads/getLatestActivityByLeadUUID",
    updateByKeyValue: "/leads/update",
    getTimeline: "/leads/getTimeline",
    filter: "/leads/filter/value",
    getNextandPreviousLead: "/leads/getNextandPreviousLead",
    markleadAsDead: "/leads/update",
    deleteLead: "/leads/deleteLead",
    reassignLead: "/leads/reassignLead",
    mergeLead: "/leads/mergeLead",
    searchLeadByName: "/leads/searchLeadByName",
    getActivityStatsByLeadUUID: "/leads/getActivityStatsByLeadUUID",
    getAllNotes: "/notes/getAllByLeadUUID",
    bookingDone: "/bookingDone/insert",
    getProjectsByLead: "/leads/getProjectsByLead",
    insertEoiDone: "/eoiDone/insert",
    insertBookingDone: "/bookingDone/insert",
    getCampaignInfo: '/leads/getCampaignInfo',
    getProjectsForFilter: '/leads/getProjectsForFilter',
    saveLeadAccess: '/leads/saveLeadAccess',
    getLeadAccess: '/leads/getLeadAccess',
    getLeadStatusShareConfig: '/leads/getLeadStatusShareConfig',
    saveLeadStatusShareConfig: '/leads/saveLeadStatusShareConfig',
    getLeadStatusShareConfigByStatusId: '/leads/getLeadStatusShareConfigByStatusId',
    getLeadStatusAssignedToConfigByStatusId: '/leads/getLeadStatusAssignedToConfigByStatusId',
    bulkLeadShare: '/leads/bulkLeadShare',
    bulkSourceChange: '/leads/bulkSourceChange'
  },
  company: {
    getMasterEums: "/company/getStatusAndIntents",
    getConfig: "/company/config",
    getUsers: "/company/getUsers",
    addUsers: "/company/inviteUser",
    getUserProfile: "/company/getUserProfile",
    getUsersForSettings: "/company/getUsersForSettings",
    // getProjects: "/company/getProjects",
    getProjects: "/projects/brokerProjectListing",
    getAllProjects: "/company/getAllProjectsByCompanyId",
    getRoles: "/company/getRoles",
    updateCompanyInfo: "/company/update",
    getDashboardCounts: "/company/getDashboardCounts",
    inviteUser: "/company/inviteUser",
    editUser: "/company/updateUserByUUID",
    deleteUser: "/company/markUserInactiveByUUID",
    deleteUserByUuid: "/company/deleteUserByUUID",
    markUserActiveByUuid: "/company/markUserActiveByUUID",
    markUserInactiveByUuid: "/company/markUserInactiveByUUID",
    resetUserPassword: "/company/resetUserPassword",
    updatePassword: "/company/updatePassword",
    getDetails: "/company/getDetails",
    insertProject: "/company/insertProject",
    getProject: "/company/getProject",
    editProject: "/company/updateProjectByUUID",
    getPersonalInfo: "/company/getCompanyOwnerProfile",
    getUserInfo: "/company/getUserProfile",
    updateOwnerByKeyAndValue: "/company/updateProfileByKeyValue",
    addProjectFormId: "/company/addProjectFormId",
    updateProjectMarketingAgency: "/company/updateFormIntegrationMarketingAgency",
    getMakeIntegrationRouting: '/company/getMakeIntegrationRouting',
    getProjectFormIds: "/company/getProjectFormIds",
    getAllApikeys: "/company/getAllApikeys",
    deleteProjectFormId: "/company/markInActiveByUUID",
    updateRolePermissions: "/company/updateRolePermissions",
    getRolePermissions: "/company/getRolePermissions",
    getLandingPage: '/company/getLandingPageIntegrations',
    addPageIntegration: '/company/createLandingPageIntegration',
    updatePageIntegration: '/company/updateLandingPageIntegration',
    markInactive: '/company/markLandingPageIntegrationInActive',
    markActive: '/company/markLandingPageIntegrationActive',
    areaByName: '/public/getAreaByName',
    deleteProjectByUuid: "/company/deleteProjectByUUID",
    generateApiKey: "/company/generateApiKey",
    projectIntergration: '/company/checkProjectIntegration',
    markRoutingEnable: '/company/enableRouting',
    markRoutingDisable: '/company/disableRouting',
    getAllCompanyAgency: '/company/getAllMarketingAgencies',
    insertAgency: '/company/insertMarketingAgency',
    updateAgency: '/company/updateMarketingAgency',
    getExportLimit: '/company/getExportLimit',
    getSubscriptionExpiry: '/company/getSubscriptionExpiry',
    updateReEngagement: '/company/updateReEngagement',
    getReEngagementStatus: '/company/getReEngagementStatus',
    saveColumnPreference: '/company/saveColumnPreference',
    getColumnPreferenceById: '/company/getColumnPreference',
    getUserColumnPreferences: '/company/getColumnPreference',
    saveColumnPreferenceNew: '/company/saveColumnPreferenceNew',
    getColumnPreferenceNew: '/company/getColumnPreferenceNew',
    getCurrentUserColumnPreference: '/company/getColumnPreferenceNew',
    updateSmsNotification: '/company/updateSmsNotification',
    getAllDevelopers: '/company/getAllDevelopers',
    getUsersForProjectLead: '/company/getUsersForProjectLead',
    getUsersForProjectRouting: '/company/getUsersForProjectRouting',
    addUserToProjectRouting: '/routingConfig/addUserToProjectRouting',
    removeUserFromProjectRouting: '/routingConfig/removeUserFromProjectRouting',
    setProjectLead: '/projects/setProjectLead',
    getProjectLead: '/projects/getProjectLead',
    updateAlternateNumberDuplicacy: '/company/updateAlternateNumberDuplicacy',
    getLandingPageIntegrationRouting: '/company/getLandingPageIntegrationRouting',
    updateNewLeadNotification: '/company/updateNewLeadNotification',
    updateSiteVisitNotification: '/company/updateSiteVisitNotification',
    getAllSourcesData: '/company/getAllSourcesData',
    addCustomSource: '/company/addCustomSource',
    renameSource: '/company/renameSource',

    // Automation 
    getSvCompletedReadAccess: '/company/getSvCompletedReadAccess',
    updateSvCompletedReadAccess: '/company/updateSvCompletedReadAccess',
    updateAutoLeadShare: '/company/updateAutoLeadShare',
    updateAutoUnassignedLeadDistribution: '/company/updateAutoUnassignedLeadDistribution',
    saveUnassignedLeadDistributionUsers: '/company/saveUnassignedLeadDistributionUsers',
    getUnassignedLeadDistributionUsers: '/company/getUnassignedLeadDistributionUsers',
    updateAutoPendingFollowupAssignment: '/company/updateAutoPendingFollowupAssignment',
    getPendingFollowupAssignment: '/company/getPendingFollowupAssignment',
    savePendingFollowupAssignment: '/company/savePendingFollowupAssignment',
    updateAutoEoiCancel: '/company/updateAutoEoiCancel',
    updateAutoCancelledEoiAssignment: '/company/updateAutoCancelledEoiAssignment',
    saveCancelledEoiAssignmentUsers: '/company/saveCancelledEoiAssignmentUsers',
    getCancelledEoiAssignmentUsers: '/company/getCancelledEoiAssignmentUsers',
    getUnassignedLeadProjectDistribution: '/leads/getUnassignedLeadProjectDistribution',
    saveUnassignedLeadProjectDistribution: '/leads/saveUnassignedLeadProjectDistribution',
    updateAutoUnassignedLeadProjectDistribution: '/company/updateAutoUnassignedLeadProjectDistribution',


    // kyc 
    updateKycDocuments: '/company/updateCompanyKyc',
    verifyOTP: '/company/verifyKyc',
    updateInterests: '/company/updateInterests',
    getKycStatus: '/company/getKycStatus',

    // rera verification
    getReraDocumentByState: '/company/getReraDocumentByState',
    insertAndUpdateReraDocument: '/company/insertAndUpdateReraDocument',
    insertEventRegisteration: '/company/insertEventRegisteration',
    getAllReraDocuments: '/company/getAllReraDocuments',

    // project dashboard
    getProjectsForCRM: '/projects/getProjectsForCRM',
    addToList: '/projects/addToUserList',
    getProjectsDetailForCRM: '/projects/getProjectsDetailForCRM',
    getProjectDataForPlusApp: '/projects/getProjectDataForPlusApp',
    insertProjectRegisteration: '/projects/insertProjectRegisteration',
    downloaAlldMedia: '/projects/downloadallMediaForCRM',
    // temp to be delete
    getProjectDetails: '/projects/listings/fetch',

    // Project creation
    insertProjectBasicDetail: '/projects/crm/insertProjectBasicDetail',
    getProjectBasicDetailsByUUID: '/projects/crm/getProjectBasicDetailsByUUID',
    updateBasicDetailsByUUID: '/projects/crm/updateBasicDetailsByUUID',
    insertConfiguration: '/projects/crm/insertConfiguration',
    getProjectConfigurations: '/projects/crm/getProjectConfigurations',
    updateConfigurationByUUID: '/projects/crm/updateConfigurationByUUID',
    updateLocation: '/projects/crm/updateLocation',
    updateAmenitiesAndBrancByUUID: '/projects/crm/updateAmenitiesAndBrancByUUID',
    updateDeveloperDetailsByUUID: '/projects/crm/updateDeveloperDetailsByUUID',
    updateOfferesByUUID: '/projects/crm/updateOfferesByUUID',
    insertBankDetail: '/projects/crm/insertBankDetail',
    getProjectBankDetails: '/projects/crm/getProjectBankDetails',
    updateBankDetailByUUID: '/projects/crm/updateBankDetailByUUID',
    insertPaymentPlan: '/projects/crm/insertPaymentPlan',
    getProjectPaymentPlans: '/projects/crm/getProjectPaymentPlans',
    updatePaymentPlanByUUID: '/projects/crm/updatePaymentPlanByUUID',
    insertProjectMedia: '/projects/crm/insertProjectMedia',
    getProjectMedia: '/projects/crm/getProjectMedia',
    updateProjectMedia: '/projects/crm/updateProjectMedia',
    getAmenities: '/public/getAmenities',
    getUnitType: '/public/getUnitType',
    getPreferredTenant: '/public/getPreferredTenant',
    getMediaName: '/public/getMediaName',
    getDocumentNames: '/public/getDocumentNames',
    insertProjectAdditionalCost: '/projects/crm/insertProjectAdditionalCost',
    getProjectProjectAdditionalCosts: '/projects/crm/getProjectProjectAdditionalCosts',
    updateProjectAdditionalCostByUUID: '/projects/crm/updateProjectAdditionalCostByUUID',
    updateProjectAdditionalDetailsByUUID: '/projects/crm/updateProjectAdditionalDetailsByUUID',
    deleteConfigurationByUUID: '/projects/crm/deleteConfigurationByUUID',
    deleteMediaByUUID: '/projects/crm/deleteMediaByUUID',
    deletePaymentPlanByUUID: '/projects/crm/deletePaymentPlanByUUID',
    deleteBankDetailByUUID: '/projects/crm/deleteBankDetailByUUID',
    deleteAdditionalCostByUUID: '/projects/crm/deleteAdditionalCostByUUID',
    getProjectSpecifications: '/projects/crm/getProjectSpecifications',
    getPaymentPlanMilestonesByProjectId: '/projects/crm/getPaymentPlanMilestonesByProjectId',
    getPaymentPlanMilestones: '/projects/crm/getPaymentPlanMilestones',
    getMilestoneDetail: '/projects/crm/getMilestoneDetail',
    insertPaymentMilestone: '/projects/insertPaymentMilestone',
    getPaymentMilestone: '/projects/getPaymentMilestone',
    updateProjectSpecification: '/projects/crm/updateProjectSpecification',
    deleteProjectSpecifications: '/projects/deleteProjectSpecifications',

    // Pricing Module
    insertPricingEOI: '/projects/crm/insertPricingEOI',
    getPricingEOI: '/projects/crm/getPricingEOI',
    insertPricingBasePrice: '/projects/crm/insertPricingBasePrice',
    getPricingBasePrice: '/projects/crm/getPricingBasePrice',
    insertPricingAmenityCharges: '/projects/crm/insertPricingAmenityCharges',
    getPricingAmenityCharges: '/projects/crm/getPricingAmenityCharges',
    insertPricingStampDuty: '/projects/crm/insertPricingStampDuty',
    getPricingStampDuty: '/projects/crm/getPricingStampDuty',
    insertPricingRegisterationCharges: '/projects/crm/insertPricingRegisterationCharges',
    getPricingRegisterationCharges: '/projects/crm/getPricingRegisterationCharges',
    insertPricingLegalCharges: '/projects/crm/insertPricingLegalCharges',
    getPricingLegalCharges: '/projects/crm/getPricingLegalCharges',
    insertPricingEDCCharges: '/projects/crm/insertPricingEDCCharges',
    getPricingEDCCharges: '/projects/crm/getPricingEDCCharges',
    insertPricingIDCCharges: '/projects/crm/insertPricingIDCCharges',
    getPricingIDCCharges: '/projects/crm/getPricingIDCCharges',
    insertPricingIFDCCharges: '/projects/crm/insertPricingIFDCCharges',
    getPricingIFDCCharges: '/projects/crm/getPricingIFDCCharges',
    insertPricingGSTCharges: '/projects/crm/insertPricingGSTCharges',
    getPricingGSTCharges: '/projects/crm/getPricingGSTCharges',
    insertPricingDelayedInterest: '/projects/crm/insertPricingDelayedInterest',
    getPricingDelayedInterest: '/projects/crm/getPricingDelayedInterest',
    insertPricingBooking: '/projects/crm/insertPricingBooking',
    getPricingBooking: '/projects/crm/getPricingBooking',
    insertPricingPLCCharges: '/projects/crm/insertPricingPLCCharges',
    getPricingPLCCharges: '/projects/crm/getPricingPLCCharges',

    changeAmenityPriceInclusion: '/projects/crm/changeAmenityPriceInclusion',
    changeStampDutyInclusion: '/projects/crm/changeStampDutyInclusion',
    changeRegisterationChargeInclusion: '/projects/crm/changeRegisterationChargeInclusion',
    changeEDCChargeInclusion: '/projects/crm/changeEDCChargeInclusion',
    changeIDCChargeInclusion: '/projects/crm/changeIDCChargeInclusion',
    changeIFDCChargeInclusion: '/projects/crm/changeIFDCChargeInclusion',
    changeGSTInclusion: '/projects/crm/changeGSTInclusion',
    changeLegalChargeInclusion: '/projects/crm/changeLegalChargeInclusion',
    changePLCChargeInclusion: '/projects/crm/changePLCChargeInclusion',


    // Update
    updatePricingEOIByUUID: '/projects/crm/updatePricingEOIByUUID',
    updatePricingBasePriceByUUID: '/projects/crm/updatePricingBasePriceByUUID',
    updatePricingAmenityChargesByUUID: '/projects/crm/updatePricingAmenityChargesByUUID',
    updatePricingEDCChargesByUUID: '/projects/crm/updatePricingEDCChargesByUUID',
    updatePricingIDCChargesByUUID: '/projects/crm/updatePricingIDCChargesByUUID',
    updatePricingIFDCChargesByUUID: '/projects/crm/updatePricingIFDCChargesByUUID',
    updatePricingStampDutyByUUID: '/projects/crm/updatePricingStampDutyByUUID',
    updatePricingRegisterationChargesByUUID: '/projects/crm/updatePricingRegisterationChargesByUUID',
    updatePricingLegalChargesByUUID: '/projects/crm/updatePricingLegalChargesByUUID',
    updatePricingGSTChargesByUUID: '/projects/crm/updatePricingGSTChargesByUUID',
    updatePricingDelayedInterestByUUID: '/projects/crm/updatePricingDelayedInterestByUUID',
    updatePricingBookingByUUID: '/projects/crm/updatePricingBookingByUUID',
    updatePricingPLCChargesByUUID: '/projects/crm/updatePricingPLCChargesByUUID',

    // Get 
    getPricingEOIByUUID: '/projects/crm/getPricingEOIByUUID',
    getPricingBasePriceByUUID: '/projects/crm/getPricingBasePriceByUUID',
    getPricingAmenityChargesByUUID: '/projects/crm/getPricingAmenityChargesByUUID',
    getPricingEDCChargesByUUID: '/projects/crm/getPricingEDCChargesByUUID',
    getPricingIDCChargesByUUID: '/projects/crm/getPricingIDCChargesByUUID',
    getPricingIFDCChargesByUUID: '/projects/crm/getPricingIFDCChargesByUUID',
    getPricingBookingByUUID: '/projects/crm/getPricingBookingByUUID',
    getPricingPLCChargesByUUID: '/projects/crm/getPricingPLCChargesByUUID',

    // Team
    getAllTeams: '/teams/getAll',
    insertTeam: '/teams/insertTeam',
    updateTeam: '/teams/updateTeam',
    addToProject: '/teams/addToProject',
    getTeamUsers: '/teams/getTeamUsers',
    updateTeamLead: '/teams/updateTeamLead',
    deleteTeamFromProject: '/teams/deleteTeamFromProject',
    getProjectTeams: '/teams/getProjectTeams',
    getTeamDetail: '/teams/getTeamDetail',
    deleteTeamUser: '/teams/deleteTeamUser',

    // Broker Module Setting

    getNewBrokerDetails: '/company/getNewBrokerDetails',
    updateProfile: '/company/updateProfileInPlusApp',
    getPaymentDetails: '/company/getPaymentDetails',
    savePaymentDetails: '/company/savePaymentDetails',
    getUserReferralCode: '/company/getUserReferralCode',
    getNewBrokerReferralDetails: '/company/getNewBrokerReferralDetails',
    getSubscriptionFAQ: '/public/getSubscriptionFAQ',
    insertNotificationDevice: '/notifications/insertNotificationDevice',
    applyCoupon: '/subscription/applyCoupon',
    intiateDeleteRequest: '/company/intiateDeleteRequest',

    // Subscriptions 
    getAllSubscriptions: '/subscription/getSubs',
    getActiveCoupons: '/subscription/getActiveCoupons',
    addSubscription: '/subscription/addSubscription',
    createOrder: '/subscription/createSubscription',
    getOrderStatus: '/subscription/getOrderStatus',


  },
  customer: {
    updateByKeyValue: "/customer/update",
    updateByKeyValue2: "/customer/updateByKeyValue2",
    updateBudget: "/customer/updateBudget",
    getEnums: "/customer/getEnums",
    updateCustomer: "/customer/update",
  },
  tags: {
    addTagToLead: "/tags/addTagToLead",
    getTagsByLeadUUID: "/tags/getTagsByLeadUUID",
    removeTagFromLead: "/tags/removeTagFromLead",
  },
  notes: {
    insert: "/notes/insert",
    getAllByLeadUUID: "/notes/getAllByLeadUUID",
    update: "/notes/update",
    removeFromLead: "/notes/removeFromLead",
  },
  followups: {
    insert: "/followups/insert",
    getAllByLeadUUID: "/followups/getAllByLeadUUID",
    update: "/followups/update",
    removeFromLead: "/followups/removeFromLead",
    canCreateFollowup: "/followups/canCreateFollowup",
    getActiveFollowupByLeadId: "/followups/getActiveFollowupByLeadId",
  },
  siteVisits: {
    insert: "/siteVisits/insert",
    getAllByLeadUUID: "/siteVisits/getAllByLeadUUID",
    update: "/siteVisits/update",
    removeFromLead: "/siteVisits/removeFromLead",
    canCreateSV: "/siteVisits/canCreate",
    markCompletedByUUID: "/siteVisits/markCompletedByUUID",
    markCancelledByUUID: '/siteVisits/markCancelledByUUID'
  },
  public: {
    isValidInvite: "/public/isValidInvite",
    companySignup: "/public/companySignup",
    getDeadReasons: "/public/getDeadReasons",
    userLogin: "/auth/login",
    isValidInvite: "/public/isValidInvite",
    getStates: "/public/getStates",
    getCities: "/public/getAllCities",
    getAllCities: '/public/getAllCities',
    getCitiesFromState: "/public/getCitiesByState",
    verifyEmail: "/public/verifyEmail",
    forgotPassword: "/public/forgotPassword",
    forgotPasswordChange: "/public/forgotPasswordChange",
    sendOTP: '/public/sendVerifyEmailOtp',
    verifyOTP: '/public/verifySignupEmail',
    resendOTP: '/public/resendVerifyEmailOtp',
    setSignupPassword: '/public/setSignupPassword',
    getSignupEmail: '/public/getSingupEmail',
    uploadFiles: '/public/getS3Url',
    sendForgotPasswordOTPEmail: '/public/sendForgotPasswordOTPEmail',
    forgotPasswordChangeOTP: '/public/forgotPasswordChangeOTP'
  },
  auth: {
    getRolePermissions: '/auth/getRolePermissions',
    sendOtpForLoginForTabletForm: '/auth/sendOtpForLoginForTabletForm',
    verifyOtpForLoginForTabletForm: '/auth/verifyOtpForLoginForTabletForm',
    // sendBrokerOtpForLogin: '/auth/sendBrokerOtpForLogin',
    // verifyOtpForLogin: '/auth/verifyOtpForLogin',
    brokerSignup: '/public/brokerSignup',
    requestCompanySignup: '/public/requestCompanySignup',
    sendBrokerOtpForLogin: '/public/sendTempOTP',
    sendTempOtpWithCompanyCode: '/public/sendTempOtpWithCompanyCode',
    verifyOtpForLogin: '/public/verifyTempOTP',
    checkForPayment: '/plusApp/checkForPayment',
    getWorkshopByUuid: '/public/getWorkshopByUUID',
    createWorkshopPaymentOrder: '/public/createWorkshopPaymentOrder',


    // New signup api
    insertTempEntry: '/public/insertTempEntry',
    verifyOTPWithUUID: '/public/verifyOTPWithUUID',
    loginWithCompany: '/public/loginWithCompany',
    inviteUser: '/brokercp/inviteUser'
  },

  plus_company: {
    approveUserRequest: '/company/approveUserRequest'
  },

  routing: {
    getUsersForIntegration: "/routingConfig/get",
    markLeadInActive: "/routingConfig/markInactiveByUUID",
    markLeadActive: "/routingConfig/markActiveByUUID",
    updateProjects: '/routingConfig/updateProjects'
  },
  analytics: {
    leadCountByStatus: '/analytics/getLeadCountWithStatus',
    leadCountBySource: '/analytics/getLeadCountWithSource',
    leadCountByIntent: '/analytics/getLeadCountByIntent',
    leadCountByAssignedTo: '/analytics/getLeadCountByAssignedTo',
    leadCountByProject: '/analytics/getLeadCountByProject',
    leadCountByProjectWithStatus: '/analytics/getLeadCountByProjectWithStatus',
    leadCountByProjectWithSource: '/analytics/getLeadCountByProjectWithSource',
    deadLeadCount: '/analytics/getDeadLeadCount',
    bookingLeadCount: '/analytics/getBookings',
    getEventsCount: '/analytics/getEventsCount',
    deadLeadCountByReason: '/analytics/getDeadLeadCountbyReason',
    employeeInsights: '/analytics/getEmployeeInsights',
    countForConversionAnalysis: '/analytics/getCountForConversionAnalysis',
    employeeEventAnalysis: '/analytics/getEmployeeEventAnalysis',
    getAllAdsByCompanyId: '/facebook/getAllAdsByCompanyId'
  },

  integration: {
    housingIntegration: '/integrations/createHousingIntegration',
    getHousingIntegration: '/integrations/getHousingIntegrations',
    markHousingActive: '/integrations/markHousingIntegrationActive',
    markHousingInActive: '/integrations/markHousingIntegrationInActive',
    viewHousingIntegration: '/integrations/viewHousingIntegration',
    updateHousingIntegration: '/integrations/updateHousingIntegration',
    getHousingProfiles: '/integrations/getHousingProfiles',
    housingToggleUnmappedLeads: '/integrations/housingToggleUnmappedLeads',

    // Magicbricks
    magicbricksIntegration: '/integrations/createMagicbricksIntegration',
    getMagicbricksIntegration: '/integrations/getMagicbricksIntegrations',
    markMagicbricksActive: '/integrations/markMagicbricksIntegrationActive',
    markMagicbricksInActive: '/integrations/markMagicbricksIntegrationInActive',
    viewMagicbricksIntegration: '/integrations/viewMagicbricksIntegration',
    updateMagicbricksIntegration: '/integrations/updateMagicbricksIntegration',
    getMagicbricksProfiles: '/integrations/getMagicbricksProfiles',
    magicbricksToggleUnmappedLeads: '/integrations/magicbricksToggleUnmappedLeads',

    // 99 Acres

    create99AcresIntegration: '/integrations/create99AcresIntegration',
    get99AcresIntegration: '/integrations/get99AcresIntegrations',
    get99AcresProfiles: '/integrations/get99AcresProfiles',
    mark99AcresActive: '/integrations/mark99AcresIntegrationActive',
    mark99AcresInActive: '/integrations/mark99AcresIntegrationInActive',
    view99AcresIntegration: '/integrations/view99AcresIntegration',
    update99AcresIntegration: '/integrations/update99AcresIntegration',
    get99AcresProfiles: '/integrations/get99AcresProfiles',
    acresToggleUnmappedLeads: '/integrations/acresToggleUnmappedLeads',
  },

  // Facebook 
  facebook: {
    getLoginApi: '/facebook/getLoginUrl',
    generateAccessToken: '/facebook/generateAccessToken',
    getLinkedAccounts: '/facebook/getLinkedAccounts',
    getPages: '/facebook/getPages',
    getPageForms: '/facebook/getPageForms',
    getCRMValues: '/facebook/getCrmValues',
    createIntegration: '/facebook/saveIntegration',
    getIntegrations: '/facebook/getIntegratedPages',
    udateActiveState: '/facebook/updateIntegratedPageStatus',
    getFormMapping: '/facebook/getMappingsByFormId',
    getPageFormByIntegrationId: '/facebook/getPageFormsByIntegrationId',
    updateIntegration: '/facebook/updateIntegration',
    getInetgrationsForms: '/facebook/getIntegratedForms',
    getIntegratedPageToEdit: '/facebook/getIntegratedPageToEdit',
    sendtestLead: '/facebook/sendTestLeads',
    importPreviousLeads: '/facebook/importPreviousLeads',
    getUnprocessedLeads: '/facebook/getUnprocessedLeads',
    resolveError: '/facebook/resolveError',
    getImportJobs: '/facebook/getImportJobs',
    getErrorInfo: '/facebook/getErrorInfo',
    deleteIntergration: '/facebook/deleteIntegratedPage',
    updateIntegratedFormActiveStateByUUID: '/facebook/updateIntegratedFormStatus',
    deleteAccount: '/facebook/deleteUser',
    getFormMappingRouting: '/facebook/getFormMappingRouting'
  },

  // IVR Integration
  ivr: {
    getMyOperatorApikey: '/ivr/getMyOperatorApikey',
    generateMyOperatorApikey: '/ivr/generateMyOperatorApikey',
    addMyOperatorIntegration: '/ivr/addMyOperatorIntegration',
    addUserMapping: '/ivr/addUserMapping',
    getIvrIntegrations: '/ivr/getIvrIntegrations',
    getIvrUserMapping: '/ivr/getIvrUserMapping',
    getIvrIntegrationByUUID: '/ivr/getIvrIntegrationByUUID',
    updateMyOperatorIntegration: '/ivr/updateMyOperatorIntegration',
    getCallLogs: '/webhooks/getCallLogs',
    getCallLogStats: '/webhooks/getCallLogStats',

    addKnowlarityIntegration: '/knowlarityIvr/addKnowlarityIntegration',
    addKnowlarityUserMapping: '/knowlarityIvr/addKnowlarityUserMapping',
    getKnowlarityIvrIntegrations: '/knowlarityIvr/getKnowlarityIvrIntegrations',
    getKnowlarityIvrUserMapping: '/knowlarityIvr/getKnowlarityIvrUserMapping',
    getKnowlarityIvrIntegrationByUUID: '/knowlarityIvr/getKnowlarityIvrIntegrationByUUID',
    updateKnowlarityIntegration: '/knowlarityIvr/updateKnowlarityIntegration',
    getKnowlarityCallLogs: '/webhooks/getKnowlarityCallLogs',
    getKnowlarityCallLogStats: '/webhooks/getKnowlarityCallLogStats'
  },

  csv: {
    uploadCSV: '/importJob/createJob',
    getReport: '/importJob/getUploadReport',
    getCsvValues: '/importJob/getValuesToMatch',
    getAllCities: '/public/getAllCities',
    insertMappingData: '/importJob/insertMapping',
    getAllJobs: '/importJob/getAll',
    saveConfig: '/importJob/saveConfigByJobId',
    processCSV: '/importJob/processCSV',
    deleteCSV: '/importJob/markDeleted',
    createExport: '/company/createExport',
    getExportLeadsCount: '/company/getExportLeadsCount',
    getExportJobs: '/company/getAllExportJobs'
  },
  workshops: {
    getAllWorkshops: "/workshop/getAllLiveWorkshops",
    getWorkshopById: "/workshop/getWorkshopById",
    getWorkshopMentorsById: "/workshop/getWorkshopMentorForUser",
    getObjectUsingSignedUrl: '/workshop/getObjectUsingSignedUrl',
    insertContinueWatching: '/workshop/insertContinueWatching',
    getContinueWatching: '/workshop/getContinueWatching',
    getUpcomingSvByBrokerId: '/siteVisits/getUpcomingSvByBrokerId'
  },
  guide: {
    get: '/guides/getAll'
  },
  courses: {
    get: '/courses/getActiveCourses',
    getCourseById: '/courses/getCourseByUUID',
    getCourseContent: '/courses/getCourseContent',
    getAllFaqs: '/courses/getAllFaqs',
    getLcActiveCategories: '/courses/getLcActiveCategories',
    insertCallRequested: '/plusApp/insertCallRequested',
    getRecentSessions: '/plusApp/getRecentSessions',
    getAllVisibleBanners: '/plusApp/getAllVisibleBanners'
  },

  launchPad: {
    get: '/launchpad/getEventsForCRM',
    insertEventRegisteration: '/launchpad/insertEventRegisteration',
    sendOTP: '/launchpad/sendOtpToJoinEvent',
    todaysLaunchpad: 'launchpad/getTodayEventsForCRM'
  },
  enroll: {
    enrollUser: "/workshop/addUserToWorkshop/",
    enrolledUser: "/workshop/checkIfUserIsEnrolled/"
  },

  // Roles
  roles: {
    create: '/roles/create',
    getMasterPermissions: '/roles/get_master_permissions',
    setPermissions: '/roles/set_permissions',
    getExistingUsers: '/roles/get_user_to_add',
    addExistingUser: '/roles/add_user',
    addNewUser: '/roles/invite_new_user',
    getUsers: '/roles/get_users',
    addProject: '/roles/add_user_project',
    addUserTeam: '/roles/add_user_team',
    addReportingUser: '/roles/add_user_reporting',
    cancelInvite: '/roles/cancel_user_invite',
    updateRoleBasicDetails: '/roles/udpate_role_basic_detail',
    getMasterRoles: '/roles/get_master_roles',
    deletedRoleByUUID: '/roles/deleteRoleByUUID',
    getRoleDetail: '/roles/role_detail',
    updateTeamLead: '/roles/update_team_lead',
    generateUserInviteLink: '/company/generateUserInviteLink'
  },

  inventory: {
    // Unit
    getUnits: '/projects/getUnits',
    updateUnitByUuid: '/projects/updateUnit',
    getUnitStatusEnum: '/projects/getUnitStatusEnum',
    getUnitBooking: '/projects/getUnitBooking',
    updateUnitAvailability: '/projects/updateUnitAvailability',

    // Booking 
    insertBookingDone: '/bookingDone/insert',
    setBookingUnitByBookingId: '/bookingDone/setBookingUnitByBookingId',
    setBrokerDetails: '/bookingDone/setBrokerDetails',
    setBookingOtherDetails: '/bookingDone/setBookingOtherDetails',
    getBookingDoneDetails: '/bookingDone/getDetails',
    getBookingDoneDetailsByLeadId: '/bookingDone/getDetailsByLeadId',
    changeBookingApprovalStatus: '/bookingDone/changeApprovalStatus',
    setPaymentPlan: '/bookingDone/setPaymentPlan',
    getUnitPricing: '/projects/crm/getUnitPricing',
    setBookingPricing: '/bookingDone/setBookingPricing',
    saveTransaction: '/bookingDone/saveTransaction',
    getDemandDetail: '/bookingDone/getDemandDetail',

    // EOI
    insertEOI: '/eoiDone/insert',
    setEOIUnitByEOIId: '/eoiDone/setBookingUnitByBookingId',
    setEOIBrokerDetails: '/eoiDone/setBrokerDetails',
    setEOIOtherDetails: '/eoiDone/setBookingOtherDetails',
    getEOIDetails: '/eoiDone/getDetails',
    getDetailsByLeadId: '/eoiDone/getDetailsByLeadId',
    changeEOIApprovalStatus: '/eoiDone/changeApprovalStatus',
    updatePreferredUnit: '/eoiDone/updatePreferredUnit',
    setEOIPricing: '/eoiDone/setBookingPricing',
    setEoiPaymentPlan: '/eoiDone/setPaymentPlan',
    getBookingPaymentMilestonesByEOIId: '/eoiDone/getBookingPaymentMilestonesByEOIId',
    raiseEOIDemand: '/eoiDone/raiseDemand',
    getEOIBookingPricing: '/eoiDone/getBookingPricing',
    getDemandDetailByEOI: '/eoiDone/getDemandDetailByEOI',
    getPendingDemandByEOIId: '/eoiDone/getPendingDemandByBookingId',
    eoiSaveTransaction: '/eoiDone/saveTransaction',
    getEOIForDiscount: '/eoiDone/getEOIForDiscount',

    // Collections
    getBookingsForCollectionManager: '/bookingDone/getBookingsForCollectionManager',
    getCollectionsByProjectId: '/bookingDone/getCollectionsByProjectId',
    getDemandsByProjectId: '/bookingDone/getDemandsByProjectId',
    getBookingPaymentMilestonesByBookingId: '/bookingDone/getBookingPaymentMilestonesByBookingId',
    raiseDemand: '/bookingDone/raiseDemand',
    getCollectionManagerStats: '/bookingDone/getCollectionManagerStats',
    getPendingDemandByBookingId: '/bookingDone/getPendingDemandByBookingId',
    addCollection: '/bookingDone/addCollection',
    getCollectionDetails: '/bookingDone/getCollectionDetails',
    updateCollectionStatus: '/bookingDone/updateCollectionStatus',
    getCollectionByBookingId: '/bookingDone/getCollectionByBookingId',
    getRaisedDemands: '/bookingDone/getRaisedDemands',
    getPaymentLedger: '/bookingDone/getPaymentLedger',
    addDebitTransaction: '/bookingDone/addDebitTransaction',
    getBankDetails: '/projects/getBankDetails',
    updateDemand: '/bookingDone/updateDemand',
    getMilestoneByDemand: '/bookingDone/getMilestoneByDemand',
    getCollectionDetailStat: '/bookingDone/getCollectionDetailStat',
    getTransactionProof: '/bookingDone/getTransactionProof',
    generateDemandPdf: '/bookingDone/generateDemandPdf',
    getAllBookingDocs: '/bookingDone/getAllBookingDocs',
    addPDC: '/bookingDone/addPDC',
    createConstructionUpdate: '/constructionUpdates/createConstructionUpdate',
    getConstructionUpdate: '/constructionUpdates/getConstructionUpdate',
    updateConstructionUpdate: '/constructionUpdates/updateConstructionUpdate',


  },
  //  Site visit flow
  tablet: {
    getSvFormConfig: '/public/getSvFormConfig',
    sendOTP: '/public/sendOTP',
    verifyOTP: '/public/verifyOTP',
    submitSiteVisitForm: '/public/submitSiteVisitForm',
    fetchBrokerCode: '/public/fetchBrokerCode',
    checkBrokerInCompany: '/public/checkBrokerInCompany',
    getBrokerCompanies: '/public/getBrokerCompanies',
    requestCompanySignup: '/public/requestCompanySignup',
    completeProjectVisit: '/public/completeProjectVisit',
    getReVisitCustomerDetails: '/public/getReVisitCustomerDetails',
    getReVisitCustomerDetailsV2: '/public/getReVisitCustomerDetailsV2',
    verifySvCode: '/public/verifySvCode',
    findCustomerWithEmailOrDocId: '/public/findCustomerWithEmailOrDocId',
    getRevisitDetailsByOpportunityUuid: '/public/getRevisitDetailsByOpportunityUuid',
    getRunningSiteVisitsCount: '/siteVisit/getRunningSiteVisitsCount',
    getRunningSiteVisits: '/siteVisit/getRunningSiteVisits',
    getMasterOtpReasons: '/public/getMasterOtpReasons',
    setClientOutTime: '/siteVisit/setClientOutTime'
  }
};

